import { apiClient } from '@borradh-workspace/api-client';
import type {
  DetectImportKindInput,
  DetectImportKindResponse,
} from '@borradh-workspace/api-client/types';
import { detectImportKindResponseSchema } from '@borradh-workspace/contracts';
import { useMutation } from '@tanstack/react-query';

/** Which importer a spreadsheet belongs to, from its headers. */
export const useDetectImportKind = () => {
  const mutation = useMutation({
    mutationFn: (input: DetectImportKindInput) =>
      apiClient.post<DetectImportKindResponse>('imports/detect', input, {
        schema: detectImportKindResponseSchema,
      }),
  });
  return {
    detectImportKind: mutation.mutateAsync,
    isDetecting: mutation.isPending,
    reset: mutation.reset,
  };
};
